import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';
import RefreshTimer from '../refresh-timer/refresh-timer';
import { Frame } from '@wwe-portal/entities/webcoin.type';
import WebCoinShopCard from '../web-coin-shop-card/web-coin-shop-card';
import { Each } from '@wwe-portal/ui/components/utils';
import { AlternativePurchaseTypes } from '@wwe-portal/web/services/payment/type';

export const PlayerAvatarDesktopList = ({
  ref,
  pacificDate,
  handleUpdateLiveList,
  avatarsList,
  handleItemsPurchase,
  purchasingOffer,
  handleWebCoinAvatarCardTitle,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  avatarsList: Frame[];
  handleItemsPurchase: ({ price, itemId, type, title }) => void;
  purchasingOffer: any;
  handleWebCoinAvatarCardTitle: (title: string) => string;
}) => {
  const t = useTranslations();

  return (
    <div id={WEBCOIN_SECTIONS.PLAYER_AVATARS}>
      <div
        ref={ref}
        className="shop-featured mb-[10px] flex justify-between pt-[30px]"
      >
        <div className="mb-0 text-xl font-semibold">{t('player_avatars')}</div>
        {pacificDate && (
          <RefreshTimer
            time={pacificDate}
            handleTimerFromChild={handleUpdateLiveList}
          />
        )}
      </div>
      <p className={`text-text600 mb-8 text-xs`}>
        {t('player_avatars_description')}
      </p>
      <div className="-mr-[10px] flex flex-wrap justify-start">
        <Each
          data={avatarsList}
          render={(item: Frame, index) => (
            <div
              key={index}
              className="3xl:basis-1/5 mb-[30px] pr-4 md:basis-1/3"
            >
              <WebCoinShopCard
                title={handleWebCoinAvatarCardTitle(item.title)}
                rarity={item.rarity}
                image={item.image}
                price={item.price}
                id={item.avatarId}
                unlocked={item.unlocked}
                handlePurchaseClick={(price, itemId, type) => {
                  handleItemsPurchase({
                    price,
                    itemId,
                    type,
                    title: item.title,
                  });
                }}
                index={index}
                listType={AlternativePurchaseTypes.Avatar}
                paymentLoading={purchasingOffer?.offerId === item.avatarId}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
};
